import React from "react";

const ArtistSearch = ({ artistSearch, setArtistSearch }) => {
  return (
    <div style={{
      background: "rgba(0, 0, 0, 0.6)",
      padding: "15px",
      borderRadius: "10px",
      color: "white",
      maxWidth: "420px",
      textAlign: "center",
    }}>
      <h3 style={{ marginTop: 0, color: "#FFD700" }}>Search Artist</h3>

      <input
        type="text"
        value={artistSearch}
        onChange={(e) => setArtistSearch(e.target.value)}
        placeholder="artist name..."
        style={{
          width: "100%",
          padding: "8px",
          borderRadius: "5px",
          border: "2px solid #FF8C00",
          background: "#111",
          color: "white",
          boxSizing: "border-box",
        }}
      />

      {artistSearch && (
        <button
          onClick={() => setArtistSearch("")}
          style={{
            marginTop: "8px",
            width: "100%",
            padding: "8px",
            borderRadius: "5px",
            border: "2px solid #FF8C00",
            background: "#222",
            color: "white",
            cursor: "pointer",
          }}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default ArtistSearch;
